import { useSyncSystemColorSchemeCookie } from '../../../../hooks/useSyncSystemColorSchemeCookie/useSyncSystemColorSchemeCookie';
import { useGlobalAppStateStore } from '../../../stores/app/GlobalAppStateStore';
import { useSyncBodyColorScheme } from './hooks/useSyncBodyColorScheme';
import { useBiometrics } from './hooks/useBiometrics';
import { useChangeInitialColorSchemeDetails } from './hooks/useChangeInitialColorSchemeDetails';
import { useInitialiseGeolocation } from './hooks/useInitialiseGeolocation';
import { useInitialiseLiveLocation } from './hooks/useInitialiseLiveLocation';
import { useInitialiseNetworkStatus } from './hooks/useInitialiseNetworkStatus';
import { useInitialiseOfflineModeStatus } from './hooks/useInitialiseOfflineModeStatus';
import { useInitialisePermissions } from './hooks/useInitialisePermissions';
import { useSetAvailableThemesAndActiveTheme } from './hooks/useSetAvailableThemesAndActiveTheme';
import { useSetDeviceAndBrowserDetails } from './hooks/useSetDeviceAndBrowserDetails';
import useSetLocationInStore from './hooks/useSetLocationInStore';
import useSetUserInStore from './hooks/useSetUserInStore';
import { useSetUserRuntimeEnvDeviceDetails } from './hooks/useSetUserRuntimeEnvDeviceDetails';
import { useSyncDeviceCapabilitiesToStore } from './hooks/useSyncDeviceCapabilitiesToStore';
import useSyncNotificationCount from './hooks/useSyncNotificationCount';
import { useUpdateBuildInfo } from './hooks/useUpdateBuildInfo';
import type { InterfaceAppSideEffectsProps } from './types';

function InterfaceAppRunnerSideEffects(props: InterfaceAppSideEffectsProps) {
  const { children, locale, initialColorSchemeDetails } = props;

  const interfaceRecordMetadata = useGlobalAppStateStore().hooks.record.useMetadata();
  const locationConfig = interfaceRecordMetadata.advanced?.location;
  const isGeoLocationTrackingEnabled = Boolean(locationConfig?.enable);

  useSyncSystemColorSchemeCookie();
  useSetLocationInStore();
  useSetUserInStore({ locale });
  useInitialiseGeolocation({ isGeoLocationTrackingEnabled });
  useInitialiseLiveLocation({
    isLiveTrackingEnabled: Boolean(locationConfig?.liveTracking),
    liveTrackingMode: locationConfig?.liveTrackingMode,
    liveTrackingIntervalMs: locationConfig?.liveTrackingIntervalMs,
    liveTrackingNotificationMessage: locationConfig?.liveTrackingNotificationMessage,
  });
  useInitialiseNetworkStatus();
  useInitialiseOfflineModeStatus();
  useInitialisePermissions();
  useBiometrics();
  useSyncDeviceCapabilitiesToStore();
  useSetDeviceAndBrowserDetails();
  useChangeInitialColorSchemeDetails(initialColorSchemeDetails);
  useSyncBodyColorScheme();
  useSetAvailableThemesAndActiveTheme();
  useUpdateBuildInfo();
  useSetUserRuntimeEnvDeviceDetails();
  useSyncNotificationCount();

  return <>{children}</>;
}

export default InterfaceAppRunnerSideEffects;
